(function() {
    'use strict';

    angular.module('mnp.tracking', [ 'ngSanitize' ]);
})();
